<template>
  <section class="section">
    <p>Let's create a new account</p>
    <b-input type="text" v-model="email" placeholder="Email" />
    <br />
    <b-input type="password" v-model="password" placeholder="Password" />
    <br />
    <b-button type="is-primary" @click="signUp">Sign Up</b-button>
    <span>
      or go back to
      <router-link to="login">Login</router-link>
    </span>
  </section>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'signUp',
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    signUp() {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(
          (user) => {
            console.log('User account created', user);
            this.$router.replace('home');
          },
          (err) => {
            console.log('Oops, user was not created', err);
          },
        );
    },
  },
};
</script>
